import React from 'react';
import { connect } from 'redux-bundler-react';
import PluginRegion from '../utils/plugin-region';

class BasicToolbar extends React.Component {
  render(){
    const { theme, componentsBasicToolbar } = this.props;
    return (
      <div className={"toolbar toolbar-top-left " + theme} style={{ left: 49}}>
        <div className="btn-group">

          <PluginRegion
            className="toolbar-horizontal"
            components={componentsBasicToolbar}
            styleOverride={{}}
          />

        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectComponentsBasicToolbar',
  BasicToolbar
);